// extracted by mini-css-extract-plugin
export default {"wysiwyg":"wysiwyg_wysiwyg__RsqXK","readonly":"wysiwyg_readonly__tqBaS"};